import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import { LectureLecturer } from '../../../../../api/types/lecturers/lectures/lecture-lecturer';
import { ProfessorLectureDb } from '../../../../../api/types/calendar-report/calendar-report-professor.type';

const toDateOrNull = (value: any): Date | null => {
  if (value == null) return null;
  const d = new Date(value as any);
  return d instanceof Date && !isNaN(d.getTime()) ? d : null;
};

export const fetchMyLecturesOperation = async (
  professorId: number,
  filters: {
    offset: number;
    limit: number;
    startDate: Date | null;
    endDate: Date | null;
  },
  setLoading: (loading: boolean) => void,
  setLectures: (rows: LectureLecturer[]) => void,
) => {
  try {
    setLoading(true);
    const res = await appApi.getProfessorLectures(professorId, filters);
    const body = res.data.body as any;
    const rows: ProfessorLectureDb[] = Array.isArray(body)
      ? (body as ProfessorLectureDb[])
      : ((body?.data ?? []) as ProfessorLectureDb[]);

    const mapped: LectureLecturer[] = rows.map((r) => {
      const startTime = toDateOrNull(r.startTime);
      const endTime = toDateOrNull(r.endTime);

      return {
        id: r.id,
        name: r.lectureName ?? '',
        startTime: startTime ?? new Date(),
        endTime: endTime ?? new Date(),
        actualStartTime: null,
        actualEndTime: null,
        classId: 0,
        classroom: r.className ?? '',
        courseId: r.courseId,
        courseName: r.courseName ?? '',
        programId: r.programId ?? 0,
        programName: r.programName ?? r.additionalProgramName ?? '',
        programStartYear: 0,
        programNumberInYear: 0,
        branch: r.branchName ?? '',
      };
    });

    if (process.env.NODE_ENV === 'development') {
      console.debug('[MyLectures] fetched lectures', {
        count: mapped.length,
        first: mapped[0]
          ? {
              id: mapped[0].id,
              startTime: mapped[0].startTime,
              endTime: mapped[0].endTime,
              programId: mapped[0].programId,
            }
          : null,
      });
    }

    setLectures(mapped);
  } catch (e) {
    console.error('fetchMyLecturesOperation failed', e);
    toast.error('טעינת המפגשים נכשלה, נסה שוב בעוד מספר רגעים');
  } finally {
    setLoading(false);
  }
};
